<template>
  <div v-if="isCheckingAuth" class="flex items-center justify-center min-h-screen">
    <div class="loading loading-spinner loading-lg"></div>
  </div>
  <template v-else>
    <router-view />
    <AppFooter v-if="route.name !== 'Landing'" />
  </template>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AppFooter from '@/components/AppFooter.vue'

const authStore = useAuthStore()
const route = useRoute()
const isCheckingAuth = ref(true)

onMounted(async () => {
  if (!authStore.authChecked) {
    await authStore.checkAuthentication()
  }
  isCheckingAuth.value = false
})
</script>
